export default __webpack_public_path__ + "static/media/Swiss-Garden-Flower.64f0839f.jpg";